<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <!-- Nevigater -->
        <v-layout mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.push('/post-approve')"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="viewData"
          >
            <span>ดูข้อมูล</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3E7662;font-weight: bold;font-size: 24px;"
          >
            <span>รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา</span>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: left;font-size: 28px;color: white"
                @click="setData"
              >
                <div style="font-weight: bold">
                  แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา
                  (RF 04_1_2563)
                </div>
                <div style="font-size: 18px;">
                  Adverse Drug Reaction Report (เฉพาะ Serious หรือ Unexpected)
                </div>
              </v-flex>
              <v-flex
                ml-8
                pt-8
                pr-8
                style="text-align: right;font-weight: bold;font-size: 13px;color: white"
              >
                <span>RF 04_1_2563</span>
              </v-flex>
            </v-layout>

            <!-- blog 1 -->
            <v-card
              class="py-12"
              style="padding-right: 80px;padding-left: 80px"
            >
              <v-layout>
                <v-flex>
                  <!-- row 1 -->
                  <v-layout pb-3>
                    <v-flex style="text-align: left;font-weight: bold;">
                      <span>1. รหัสโครงการ</span>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex>
                      <textfield-form
                        :model="form.research_pass"
                        @update-data="updateData('research_pass', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout pb-3>
                    <v-flex style="text-align: left;font-weight: bold;">
                      <span>2. ชื่อโครงการวิจัย</span>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex>
                      <textarea-form
                        :model="form.researchName"
                        @update-data="updateData('researchName', $event)"
                      ></textarea-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout pb-3>
                    <v-flex style="text-align: left;font-weight: bold;">
                      <span>3. ชื่อผู้วิจัยหลัก</span>
                    </v-flex>
                  </v-layout>
                  <v-layout px-4>
                    <v-flex style="color: #3E7662">
                      <textfield-form
                        label="ชื่อ"
                        :model="form.fname"
                        @update-data="updateData('fname', $event)"
                      ></textfield-form>
                    </v-flex>
                    <v-flex ml-3 style="color: #3E7662">
                      <textfield-form
                        label="นามสกุล"
                        :model="form.lname"
                        @update-data="updateData('lname', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 4 -->
                  <v-layout pb-3>
                    <v-flex style="text-align: left;font-weight: bold;">
                      <span>4. สังกัด / เบอร์โทรศัพท์ติดต่อ</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pb-3>
                    <v-flex>
                      <textfield-form
                        :model="form.party"
                        @update-data="updateData('party', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 5 -->

                  <!-- row 5 -->
                  <v-layout pb-3 justify-space-between>
                    <v-flex
                      mr-6
                      shrink
                      d-flex
                      align-center
                      style="text-align: left;font-weight: bold;"
                    >
                      <span>5. อาสาสมัคร</span>
                    </v-flex>
                    <v-flex>
                      <v-radio-group
                        v-model="form.volunteer_checkbox"
                        @change="clearData"
                      >
                        <v-layout my-3 align-center>
                          <v-flex>
                            <v-radio
                              color="#3E7662"
                              label="ในสถาบัน"
                              value="1"
                            ></v-radio>
                          </v-flex>
                        </v-layout>
                        <v-layout my-3 align-center>
                          <v-flex shrink>
                            <v-radio
                              color="#3E7662"
                              label="ประเทศไทย"
                              value="2"
                            ></v-radio>
                          </v-flex>
                          <v-flex pl-4>
                            <textfield-form
                              :background-color="
                                !form.volunteer_checkbox ? 'gray' : '#FBF6F3'
                              "
                              :disabled="form.volunteer_checkbox !== '2'"
                              hide-detail
                              :model="form.volunteer"
                              @update-data="updateData('volunteer', $event)"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                        <v-layout my-3 align-center>
                          <v-flex shrink>
                            <v-radio
                              color="#3E7662"
                              label="ต่างประเทศ"
                              value="3"
                            ></v-radio>
                          </v-flex>
                          <v-flex pl-4>
                            <textfield-form
                              :background-color="
                                !form.volunteer_checkbox ? 'gray' : '#FBF6F3'
                              "
                              :disabled="form.volunteer_checkbox !== '3'"
                              hide-detail
                              :model="form.volunteerForeign"
                              @update-data="
                                updateData('volunteerForeign', $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <!-- row 6 -->
                  <v-layout pt-6 justify-space-between>
                    <v-flex
                      mr-10
                      shrink
                      d-flex
                      align-center
                      style="text-align: left;font-weight: bold;"
                    >
                      <span>6. ชื่อย่อ/รหัสอาสาสมัคร Patient Initial</span>
                    </v-flex>
                    <v-flex d-flex align-center>
                      <textfield-form
                        hide-detail
                        :model="form.patient_initial"
                        @update-data="updateData('patient_initial', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 7 -->
                  <v-layout pt-10>
                    <v-flex
                      xs2
                      mr-10
                      d-flex
                      align-center
                      style="text-align: left;font-weight: bold;"
                    >
                      <span>7. วันเกิด</span>
                    </v-flex>
                    <v-flex xs2 d-flex align-center>
                      <DateInputForm
                        hide-detail
                        :model="birthDate"
                        @update-data="updateDate('birthDate', $event)"
                      ></DateInputForm>
                    </v-flex>
                    <v-flex justify-end xs2 d-flex align-center>
                      <span style="text-align: left;font-weight: bold;"
                        >8. อายุ</span
                      >
                    </v-flex>
                    <v-flex xs2 mx-4 d-flex align-center>
                      <textfield-form
                        hide-detail
                        :model="form.year"
                        @update-data="updateData('year', $event)"
                      ></textfield-form>
                    </v-flex>
                    <v-flex xs2 d-flex align-center>
                      <span style="text-align: left;font-weight: bold;"
                        >ปี</span
                      >
                    </v-flex>
                  </v-layout>
                  <!-- row 8 -->
                  <v-layout mt-4>
                    <v-flex
                      xs2
                      mr-10
                      d-flex
                      align-center
                      style="text-align: left;font-weight: bold;"
                    >
                      <span>9. เพศ</span>
                    </v-flex>
                    <v-flex pt-6 d-flex align-center style="text-align: left;">
                      <v-radio-group v-model="form.sex" row>
                        <v-radio
                          color="#3E7662"
                          style="padding-right: 40px"
                          label="ชาย"
                          value="0"
                        ></v-radio>
                        <v-radio
                          color="#3E7662"
                          label="หญิง"
                          value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <!-- row 9 -->
                  <v-layout mt-4>
                    <v-flex
                      xs2
                      mr-10
                      d-flex
                      align-center
                      style="text-align: left;font-weight: bold;"
                    >
                      <span>10. วันที่เกิดอาการ</span>
                    </v-flex>
                    <v-flex xs2 d-flex align-center>
                      <DateInputForm
                        hide-detail
                        :model="dateSymptom"
                        @update-data="updateDate('dateSymptom', $event)"
                      ></DateInputForm>
                    </v-flex>
                  </v-layout>
                  <!-- row 9 -->
                  <v-layout mb-3 mt-10>
                    <v-flex style="text-align: left;font-weight: bold;">
                      <span
                        >11.รายละเอียดเหตุการณ์ไม่พึงประสงค์
                        (รวมทั้งการตรวจทางห้องปฏิบัติการ)</span
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex>
                      <textarea-form
                        hide-detail
                        :model="form.detail_events"
                        @update-data="updateData('detail_events', $event)"
                        :rows="8"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- blog 2 -->
            <v-layout mt-12 style="background-color: #3E7662;">
              <v-flex pl-6 my-5 ml-8 style="font-size: 18px;color: white">
                <span>ข้อมูลยา (Suspect drugs information)</span>
              </v-flex>
            </v-layout>
            <v-layout
              py-12
              style="background-color: white;padding-left: 60px;padding-right: 70px;"
            >
              <v-flex>
                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span
                      >12.ยาที่ใช้ (Suspect drugs) ทั้ง Generic name และ Trade
                      name</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :model="form.suspect_drug"
                      @update-data="updateData('suspect_drug', $event)"
                    />
                  </v-flex>
                </v-layout>
                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>13.ขนาดยา (Daily doses)</span>
                  </v-flex>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>14.วิธีให้ยา (Route)</span>
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :model="form.daily_doses"
                      @update-data="updateData('daily_doses', $event)"
                    />
                  </v-flex>
                  <v-flex pl-10 style="text-align: left;">
                    <textarea-form
                      :model="form.route"
                      @update-data="updateData('route', $event)"
                    />
                  </v-flex>
                </v-layout>
                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>15.ข้อบ่งชี้ของการให้ยา (Indications)</span>
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :model="form.indications"
                      @update-data="updateData('indications', $event)"
                    />
                  </v-flex>
                </v-layout>
                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span
                      >16.วันที่เริ่มให้ยา และระยะเวลาการให้ยา (Therapy date and
                      duration)</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :model="form.TherapyDateAndDuration"
                      @update-data="
                        updateData('TherapyDateAndDuration', $event)
                      "
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Blog 3 -->
            <v-layout style="background-color: #3E7662;">
              <v-flex pl-6 my-5 ml-8 style="font-size: 18px;color: white">
                <span>ยาที่ให้ร่วม (Concomitant drugs and history)</span>
              </v-flex>
            </v-layout>
            <v-layout
              py-12
              style="background-color: white;padding-left: 60px;padding-right: 70px;"
            >
              <v-flex>
                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span
                      >17.ยาที่ให้ร่วม และวันที่ให้ยา
                      (ไม่รวมยาที่ใช้เพื่อรักษาอาการไม่พึงประสงค์จากยา)</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :model="form.date_medication"
                      @update-data="updateData('date_medication', $event)"
                    />
                  </v-flex>
                </v-layout>
                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span
                      >18.ประวัติอื่นที่อาจเกี่ยวข้อง เช่น การแพ้ยา
                      การตรวจทางห้องปฏิบัติการ การตั้งครรภ์</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :model="form.other_history"
                      @update-data="updateData('other_history', $event)"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Blog 4 -->
            <v-layout style="background-color: #3E7662;">
              <v-flex pl-6 my-5 ml-8 style="font-size: 18px;color: white">
                <span>ข้อมูลบริษัทผลิตยา (Manufacturer Information)</span>
              </v-flex>
            </v-layout>
            <v-layout
              py-12
              style="background-color: white;padding-left: 60px;padding-right: 70px;"
            >
              <v-flex>
                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>19.ชื่อ ที่อยู่ บริษัทยา</span>
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :model="form.pharmaceutical_company_address"
                      @update-data="
                        updateData('pharmaceutical_company_address', $event)
                      "
                    />
                  </v-flex>
                </v-layout>

                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>20.รหัสยา</span>
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex xs6 style="text-align: left;">
                    <textfield-form
                      :model="form.pharmaceuticalCode"
                      @update-data="updateData('pharmaceuticalCode', $event)"
                    />
                  </v-flex>
                </v-layout>

                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>21. ชนิดของการรายงาน</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.reportType" row>
                      <v-radio
                        color="#3E7662"
                        style="padding-right: 100px"
                        label="ครั้งแรก Initial report"
                        value="0"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="เพื่อติดตาม Follow-up report"
                        value="1"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-6 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>22. เหตุการณ์ที่เกิดขึ้น</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.incident">
                      <v-radio
                        color="#3E7662"
                        label="คาดว่าอาจจะเกิด"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="ไม่คาดว่าจะเกิด Unexpected (ไม่ได้ระบุในโครงร่างการวิจัยหรือ Investigator brochure)"
                        value="2"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="Nature"
                        value="3"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="Severity"
                        value="4"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="Frequency"
                        value="5"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-6 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span
                      >23. ความสัมพันธ์กับยาที่ใช้ในการวิจัย (Relation to the
                      study)</span
                    >
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.relationStudy">
                      <v-radio
                        color="#3E7662"
                        label="ไม่เกี่ยวข้อง (Not related)"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="อาจเกี่ยวข้อง (Possibly related)"
                        value="2"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="น่าจะเกี่ยวข้อง (Probably related)"
                        value="3"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="เกี่ยวข้องแน่นอน (Definitely related)"
                        value="4"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="ไม่รู้ (Unknown)"
                        value="5"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-6 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>24. ลงนามผู้วิจัย</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <TextfieldForm
                      style="color: #3E7662"
                      label="ชื่อ"
                      :model="form.signedResearcherFname"
                      @update-data="updateData('signedResearcherFname', $event)"
                    />
                  </v-flex>
                  <v-flex ml-12>
                    <TextfieldForm
                      style="color: #3E7662"
                      label="นามสกุล"
                      :model="form.signedResearcherLname"
                      @update-data="updateData('signedResearcherLname', $event)"
                    />
                  </v-flex>
                </v-layout>

                <v-layout mt-8>
                  <v-flex
                    shrink
                    mr-10
                    d-flex
                    align-center
                    style="text-align: left;font-weight: bold;"
                  >
                    <span>25. วันที่รายงาน</span>
                  </v-flex>
                  <v-flex xs2 d-flex align-center>
                    <DateInputForm
                      hide-detail
                      :model="reportDate"
                      @update-data="updateDate('reportDate', $event)"
                    ></DateInputForm>
                  </v-flex>
                </v-layout>

                <v-layout mt-8 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>ก. ตรวจสอบความร้ายแรง (severity)</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.severity">
                      <v-radio
                        color="#3E7662"
                        label="1. ตาย (Death)"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="2. รุนแรงและอาจทำให้เสียชีวิต (Life threatening)"
                        value="2"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="3. ต้องรักษาในโรงพยาบาล (Hospitalization / prolonged hospitalization)"
                        value="3"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="4. พิการหรือทุพลภาพ (Persistent or significant disability / incapacity)"
                        value="4"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="5. ทารกพิการแต่กำเนิด (Congenital anomaly / birth defect)"
                        value="5"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="6. ไม่ร้ายแรง"
                        value="6"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-8 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>ข. อาการหายไปหลังหยุดยาหรือไม่</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.symptomDisappear" row>
                      <v-radio
                        color="#3E7662"
                        label="หายไป"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="ไม่หาย"
                        value="2"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="ตอบไม่ได้"
                        value="3"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-8 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>ค. อาการเกิดขึ้นใหม่ เมื่อกลับให้ยาอีกหรือไม่</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.hasRecurrentAfterStop" row>
                      <v-radio
                        color="#3E7662"
                        label="เกิดซ้ำ"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="ไม่เกิดอีก"
                        value="2"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="ตอบไม่ได้"
                        value="3"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-8 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>ง. การดำเนินเหตุการณ์ (Progression)</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.progression" row>
                      <v-radio
                        color="#3E7662"
                        label="1. แก้ไขแล้ว (Resolved)"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="2. ยังคงมีปัญหา (Ongoing)"
                        value="2"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-8 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>จ. การเปลี่ยนแปลงโครงร่างการวิจัย</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.changesResearchProposal">
                      <v-radio
                        color="#3E7662"
                        label="1. ไม่เปลี่ยน"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 02_2560 ให้คณะอนุกรรมการฯ)"
                        value="2"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-8 mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>ฉ. การเปลี่ยนแปลงเอกสารชี้แจงข้อมูลอาสาสมัคร</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-4>
                  <v-flex>
                    <v-radio-group v-model="form.changeClarificationDocument">
                      <v-radio
                        color="#3E7662"
                        label="1. ไม่เปลี่ยน"
                        value="1"
                      ></v-radio>
                      <v-radio
                        color="#3E7662"
                        label="2. เปลี่ยน (ส่งรายงานส่วนแก้ไขเพิ่มเติมโครงร่าง การวิจัย RF 02_2560 ให้คณะอนุกรรมการฯ)"
                        value="2"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <v-layout mt-12 mb-8>
                  <v-flex
                    style="color: #CC3D45;font-size: 14px;text-align: left;"
                  >
                    <span>
                      *ถ้าเป็นเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรง(ก 1-5)
                      ผู้วิจัยควรส่งรายงานแก่คณะอนุกรรมการพิจารณาโครงการวิจัย
                      พบ. ภายใน 7 วัน หลังทราบเหตุการณ์
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Blog 5 -->
            <v-layout mt-12 style="background-color: #3E7662;">
              <v-flex pl-6 my-5 ml-8 style="font-size: 18px;color: white">
                <span>Naranjo’s algorithm</span>
              </v-flex>
            </v-layout>
            <v-layout
              py-12
              style="background-color: white;padding-left: 60px;padding-right: 70px;"
            >
              <v-flex>
                <v-layout mb-3>
                  <v-flex xs6 style="text-align: left;font-weight: bold;">
                    <span>ชื่อยา</span>
                  </v-flex>
                  <v-flex xs6 style="text-align: left;font-weight: bold;">
                    <span>เลขที่แบบรายงาน</span>
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex pr-12 xs6 style="text-align: left;">
                    <textfield-form
                      :model="form.drugName"
                      @update-data="updateData('drugName', $event)"
                    />
                  </v-flex>
                  <v-flex xs6 style="text-align: left;">
                    <textfield-form
                      :model="form.reportNumber"
                      @update-data="updateData('reportNumber', $event)"
                    />
                  </v-flex>
                </v-layout>

                <v-layout mb-3>
                  <v-flex style="text-align: left;font-weight: bold;">
                    <span>อาการไม่พึ่งประสงค์</span>
                  </v-flex>
                </v-layout>
                <v-layout mb-4>
                  <v-flex style="text-align: left;">
                    <textarea-form
                      :rows="7"
                      :model="form.symptom"
                      @update-data="updateData('drugName', $event)"
                    />
                  </v-flex>
                </v-layout>

                <v-card>
                  <!-- header -->
                  <v-layout
                    py-3
                    style="background-color: #3E7662;color: white;"
                  >
                    <v-flex
                      xs8
                      pr-12
                      pl-12
                      style="text-align: left;font-size: 18px"
                      >คำถาม</v-flex
                    >
                    <v-flex xs1 pr-8>ใช่</v-flex>
                    <v-flex xs1 pr-8>ไม่ใช่</v-flex>
                    <v-flex xs1 pr-8>ไม่ทราบ</v-flex>
                    <v-flex xs1 pr-4>คะแนน</v-flex>
                  </v-layout>
                  <!-- row detail -->
                  <v-layout pl-6 py-3>
                    <v-flex xs8 pt-2 pr-12 style="text-align: left"
                      >1.
                      เคยมีสรุปหรือรายงานการเกิดปฏิกิริยานี้มาแล้วหรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point1"
                        @update-data="updateData('point1', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3 style="background-color: #FBF6F3;">
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >2.
                      อาการไม่พึงประสงค์นี้เกิดขึ้นภายหลังจากได้รับยาที่คิดว่าเป็นสาเหตุหรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point2"
                        @update-data="updateData('point2', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3>
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >3. อาการไม่พึงประสงค์นี้ดีขึ้นเมื่อหยุดยาดังกล่าว
                      หรือเมื่อให้ยาต้านที่จำเพาะเจาะจง (specific antagonist)
                      หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point3"
                        @update-data="updateData('point3', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3 style="background-color: #FBF6F3;">
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >4.
                      อาการไม่พึงประสงค์ดังกล่าวเกิดขึ้นเมื่อเริ่มให้ยาใหม่หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point4"
                        @update-data="updateData('point4', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3>
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >5. ปฏิกิริยาที่เกิดขึ้นสามารถเกิดจากสาเหตุอื่น
                      (นอกเหนือจากยา) ของอาสาสมัครได้หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point5"
                        @update-data="updateData('point5', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3 style="background-color: #FBF6F3;">
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >6. ปฏิกิริยาดังกล่าวเกิดขึ้นอีก เมื่อให้ยาหลอก
                      หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point6"
                        @update-data="updateData('point6', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3>
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >7. ตรวจวัดปริมาณยาได้ในเลือด(หรือของเหลวอื่น)
                      ในปริมาณความเข้มข้นที่เป็นพิษ หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point7"
                        @update-data="updateData('point7', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3 style="background-color: #FBF6F3;">
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >8. ปฏิกิริยารุนแรงที่เกิดขึ้นเมื่อเพิ่มขนาดยา
                      หรือลดความรุนแรงลงเมื่อลดขนาดยา หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point8"
                        @update-data="updateData('point8', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3>
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >9.
                      อาสาสมัครเคยมีประวัติเกิดปฏิกิริยาเหมือนหรือคล้ายคลึงกันนี้มาก่อน
                      เมื่อได้รับยาชนิดนี้ หรือ ยาในกลุ่มเดียวกันในครั้งก่อนๆ
                      หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point9"
                        @update-data="updateData('point9', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout pl-6 py-3 style="background-color: #FBF6F3;">
                    <v-flex xs8 pt-2 pr-12 style="text-align: left;"
                      >10. อาการไม่พึงประสงค์นี้
                      ได้รับการยืนยันโดยหลักฐานที่เป็นรูปธรรม (objective
                      evidence) หรือไม่</v-flex
                    >
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">+1</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold">0</v-flex>
                    <v-flex xs1 pt-2 pr-8 style="font-weight: bold;">0</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.point10"
                        @update-data="updateData('point10', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <!-- footer -->
                  <v-layout
                    py-3
                    style="background-color: #3E7662;color: white;"
                  >
                    <v-flex xs8>รวม</v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.sumYes"
                        @update-data="updateData('point10', $event)"
                      />
                    </v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.sumNo"
                        @update-data="updateData('point10', $event)"
                      />
                    </v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.sumUnknown"
                        @update-data="updateData('point10', $event)"
                      />
                    </v-flex>
                    <v-flex xs1 pr-3 style="font-weight: bold">
                      <textfield-form
                        hide-detail
                        :model="form.sumPoint"
                        @update-data="updateData('point10', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-card>

                <v-layout pl-12 mt-8>
                  <v-flex style="text-align: left;font-weight: bold">
                    <span>ระดับคะแนน</span>
                  </v-flex>
                </v-layout>
                <v-layout pl-12 pt-2>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>คะแนนมากกว่าหรือเท่ากับ 9</span>
                  </v-flex>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>Definite (certain) ใช่แน่</span>
                  </v-flex>
                </v-layout>
                <v-layout pl-12 pt-2>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>คะแนนเท่ากับ 5 – 3</span>
                  </v-flex>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>Probable ใช่</span>
                  </v-flex>
                </v-layout>
                <v-layout pl-12 pt-2>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>คะแนนเท่ากับ1 – 4</span>
                  </v-flex>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>Possible อาจจะใช่</span>
                  </v-flex>
                </v-layout>
                <v-layout pl-12 pt-2>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>คะแนนน้อยกว่าหรือเท่ากับ 0</span>
                  </v-flex>
                  <v-flex xs3 style="text-align: left;font-size: 14px">
                    <span>Doubtful (unlikely) น่าสงสัย (ไม่น่าใช่)</span>
                  </v-flex>
                </v-layout>

                <v-layout pt-10>
                  <v-spacer></v-spacer>
                  <v-flex
                    xs6
                    style="font-weight: bold"
                    class="text-field-center"
                  >
                    <textfield-form-append
                      label="ลงชื่อผู้ประเมิน"
                      icon="edit"
                      :model="form.signature"
                      @update-data="updateData('signature', $event)"
                    />
                  </v-flex>
                </v-layout>

                <v-layout mt-2>
                  <v-spacer></v-spacer>
                  <v-flex
                    xs6
                    pt-2
                    mr-4
                    shrink
                    style="font-weight: bold;text-align: right;margin-left: -50px"
                  >
                    <span>วันที่</span>
                  </v-flex>
                  <v-flex xs3 style="font-weight: bold">
                    <DateInputForm
                      :model="date"
                      @update-data="updateDate('date', $event)"
                    />
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <v-layout px-12 mb-8 pt-10>
                  <v-flex
                    xs11
                    style="text-align: left;font-size: 14px; color: #3E7662"
                  >
                    <span>
                      อ้างอิง และ ปรับปรุงจากวารสารวิชาการสาธารณสุข 2559 ปีที่
                      25 ฉบับที่ 4หน้า 673-682 และ Naranjo CA, Busto U, Sellers
                      EM, et al. (1981). “A method for estimating the
                      probability of adverse drug reactions”. Clin. Pharmacol.
                      Ther. 30(2):239-45.
                    </span>
                  </v-flex>
                </v-layout>

                <v-layout pt-12 justify-space-between="">
                  <v-flex d-flex justify-start>
                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                  </v-flex>
                  <v-flex d-flex justify-end>
                    <span>หน้า 1 จาก 1 หน้า</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <!-- Button Save -->
            <v-layout mt-6>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click="viewData"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <v-icon class="mr-3">add</v-icon>
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";

export default {
  name: "FormRF06",
  components: {
    TextfieldFormAppend,
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    // TextfieldFormAppend,
    // DateInputFormAppend,
    // FormTable,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    form: {
      research_pass: "",
      researchName: "",
      fname: "",
      lname: "",
      party: "",
      volunteer_checkbox: false,
      volunteer: "",
      volunteerForeign: "",
      patient_initial: "",
      birthDate: "",
      year: "",
      sex: "",
      dateSymptom: "",
      detail_events: "",
      suspect_drug: "",
      daily_doses: "",
      route: "",
      indications: "",
      TherapyDateAndDuration: "",
      date_medication: "",
      other_history: "",
      pharmaceutical_company_address: "",
      pharmaceuticalCode: "",
      reportType: "",
      incident: "",
      relationStudy: "",
      signedResearcherFname: "",
      signedResearcherLname: "",
      reportDate: "",
      severity: "",
      symptomDisappear: "",
      hasRecurrentAfterStop: "",
      progression: "",
      changesResearchProposal: "",
      changeClarificationDocument: "",
      drugName: "",
      reportNumber: "",
      symptom: "",
      point1: "",
      point2: "",
      point3: "",
      point4: "",
      point5: "",
      point6: "",
      point7: "",
      point8: "",
      point9: "",
      point10: "",
      sumYes: "",
      sumNo: "",
      sumUnknown: "",
      sumPoint: "",
      signature: "",
      date: "",
    },
    birthDate: "",
    date: "",
    dateSymptom: "",
    reportDate: "",
    userID: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    //if (this.user.currentRole !== 3) {
    //     this.$router.go(-1);
    // }

    this.userID = this.$route.query.userID;
    this.getRF04_1();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "birthDate") {
        this.form.birthDate = val.date;
        this.birthDate = this.changeDate(val.date);
      }
      if (name === "dateSymptom") {
        this.form.dateSymptom = val.date;
        this.dateSymptom = this.changeDate(val.date);
      }
      if (name === "reportDate") {
        this.form.reportDate = val.date;
        this.reportDate = this.changeDate(val.date);
      }
      if (name === "date") {
        this.form.date = val.date;
        this.date = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    viewData() {
      this.$router.push({
        name: "ViewDataPostApprove",
        query: { id: this.userID },
      });
    },
    getRF04_1() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF04_1", this.$route.query.rfID)
        .then((res) => {
          this.form.research_pass = res.research_pass;
          this.form.researchName = res.researchName;
          this.form.fname = res.fname;
          this.form.lname = res.lname;
          this.form.party = res.party;
          this.form.volunteer_checkbox = res.volunteer_checkbox;
          this.form.volunteer = res.volunteer;
          this.form.volunteerForeign = res.volunteerForeign;
          this.form.patient_initial = res.patient_initial;
          this.form.birthDate = res.birthDate;
          this.birthDate = this.changeDate(res.birthDate);
          this.form.year = res.year;
          this.form.sex = res.sex;
          this.form.dateSymptom = res.dateSymptom;
          this.dateSymptom = this.changeDate(res.dateSymptom);
          this.form.detail_events = res.detail_events;
          this.form.suspect_drug = res.suspect_drug;
          this.form.daily_doses = res.daily_doses;
          this.form.route = res.route;
          this.form.indications = res.indications;
          this.form.TherapyDateAndDuration = res.TherapyDateAndDuration;
          this.form.date_medication = res.date_medication;
          this.form.other_history = res.other_history;
          this.form.pharmaceutical_company_address =
            res.pharmaceutical_company_address;
          this.form.pharmaceuticalCode = res.pharmaceuticalCode;
          this.form.reportType = res.reportType;
          this.form.incident = res.incident;
          this.form.relationStudy = res.relationStudy;
          this.form.signedResearcherFname = res.signedResearcherFname;
          this.form.signedResearcherLname = res.signedResearcherLname;
          this.form.reportDate = res.reportDate;
          this.reportDate = this.changeDate(res.reportDate);
          this.form.severity = res.severity;
          this.form.symptomDisappear = res.symptomDisappear;
          this.form.progression = res.progression;
          this.form.changesResearchProposal = res.changesResearchProposal;
          this.form.changeClarificationDocument =
            res.changeClarificationDocument;
          this.form.drugName = res.drugName;
          this.form.reportNumber = res.reportNumber;
          this.form.symptom = res.symptom;
          this.form.point1 = res.point1;
          this.form.point2 = res.point2;
          this.form.point3 = res.point3;
          this.form.point4 = res.point4;
          this.form.point5 = res.point5;
          this.form.point6 = res.point6;
          this.form.point7 = res.point7;
          this.form.point8 = res.point8;
          this.form.point9 = res.point9;
          this.form.point10 = res.point10;
          this.form.sumYes = res.sumYes;
          this.form.sumNo = res.sumNo;
          this.form.sumUnknown = res.sumUnknown;
          this.form.sumPoint = res.sumPoint;
          this.form.signature = res.signature;
          this.form.date = res.date;
          this.date = this.changeDate(res.date);
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.$store
            .dispatch("FormRF/saveRF04_1", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              this.viewData();
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // });
              // this.isLoading = false;
            });
        }
      });
    },
    setData() {
      this.form.research_pass = "001";
      this.form.researchName = "โครงการทดสอบ";
      this.form.fname = "ดำ";
      this.form.lname = "ใจดี";
      this.form.party = "0555555555";
      this.form.volunteer_checkbox = true;
      this.form.volunteer = "test";
      this.form.patient_initial = "ชื่อย่อ/รหัสอาสาสมัคร Patient Initial";
      this.form.birthDate = new Date().toISOString().substr(0, 10);
      this.form.year = "25";
      this.form.sex = "0";
      this.form.dateSymptom = new Date().toISOString().substr(0, 10);
      this.form.detail_events =
        "รายละเอียดเหตุการณ์ไม่พึงประสงค์ (รวมทั้งการตรวจทางห้องปฏิบัติการ)";
      this.form.suspect_drug = "test";
      this.form.daily_doses = "test";
      this.form.route = "test";
      this.form.indications = "test";
      this.form.TherapyDateAndDuration = "test";
      this.form.date_medication = "test";
      this.form.other_history = "test";
      this.form.pharmaceutical_company_address = "test";
      this.form.pharmaceuticalCode = "test";
      this.form.reportType = "0";
      this.form.incident = "1";
      this.form.relationStudy = "1";
      this.form.signedResearcherFname = "ดำ";
      this.form.signedResearcherLname = "ใจดี";
      this.form.reportDate = new Date().toISOString().substr(0, 10);
      this.form.severity = "1";
      this.form.symptomDisappear = "1";
      this.form.hasRecurrentAfterStop = "1";
      this.form.progression = "1";
      this.form.changesResearchProposal = "1";
      this.form.changeClarificationDocument = "1";
      this.form.drugName = "ยาทดสอบ";
      this.form.reportNumber = "001";
      this.form.symptom = "ไม่ทราบ";
      this.form.point1 = "1";
      this.form.point2 = "1";
      this.form.point3 = "1";
      this.form.point4 = "1";
      this.form.point5 = "1";
      this.form.point6 = "1";
      this.form.point7 = "1";
      this.form.point8 = "1";
      this.form.point9 = "1";
      this.form.point10 = "1";
      this.form.sumYes = "";
      this.form.sumNo = "";
      this.form.sumUnknown = "";
      this.form.sumPoint = "10";
      this.form.signature = "จอร์น ชาวไร่";
      this.form.date = new Date().toISOString().substr(0, 10);
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
</style>
